import styled, { css } from "styled-components";

import theme, { scrollBarStyles } from "@/utils/theme";
import Text from "@/components/Text";

export const Box = styled.div`
  z-index: 3;
  position: absolute;
  right: 0;
  top: calc(100% + 12px);
  width: 243px;
  background: ${theme.colors.white};
  border-radius: 4px;
  box-shadow: 0px 0px 8px rgba(37, 40, 43, 0.12);
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  margin: 0 16px;
  padding: 11px 0 9px;
  border-bottom: 1px solid ${({ theme }) => theme.colors.grayscaleLight};
  button {
    flex-shrink: 0;
    margin-left: auto;
  }
`;

export const Footer = styled.div`
  margin: 0 16px;
  width: calc(100% - 32px);
  display: flex;
  align-items: center;
  padding: 10px 0 12px;
  border-top: 1px solid ${({ theme }) => theme.colors.grayscaleLight};
  svg {
    margin-right: 8px;
    flex-shrink: 0;
  }
`;

export const Title = styled(Text)`
  margin-top: 12px;
  margin-bottom: 8px;
  padding: 0 8px;
  width: 100%;
  display: flex;
  align-items: baseline;
  justify-content: space-between;
`;
export const Inner = styled.div`
  max-height: 420px;
  overflow-y: auto;
  padding: 0 8px 12px;
  ${scrollBarStyles};
`;

type ItemProps = {
  $hidden?: boolean;
  $disabled?: boolean;
};

export const Item = styled.div<ItemProps>`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  padding-right: 0;
  border-radius: 4px;
  margin-top: 4px;
  transition: 0.2s ease-out background-color;
  svg {
    margin-right: 13px;
    flex-shrink: 0;
  }
  &:hover,
  &:active {
    background-color: ${({ theme }) => theme.colors.grayscaleLight};
  }
  ${({ $hidden }) =>
    $hidden &&
    css`
      svg {
        color: ${({ theme }) => theme.colors.gray};
      }
    `}
  ${({ $disabled }) =>
    $disabled &&
    css`
      &:hover,
      &:active {
        background-color: ${({ theme }) => theme.colors.white};
      }
    `}
`;
